module.exports = __webpack_public_path__ + "static/instacartnew-ab38f96a2ee74e614497358bf3e0fa4e.png";